import React from 'react'
import { assets } from '../assets/assets'
import { BsArrowRight } from "react-icons/bs";
import { Link } from 'react-router-dom';



const Account = () => {
  return (
    <div>
        <div className="breadcrumb_sec">
        <div className="container">
            <div className="support pb-3">
                <h3>My Account</h3>
                <p>Track Contributions, Manage Preferences, and Support Your Causes Effortlessly</p>
            </div>
        </div>
    </div>

    <div className="my_account_sec pb-5 pt-5">
        <div className="container">
            <div className="row gy-4 mb-4 d-flex align-items-center">
                <div className="col-xl-6">
                    <div className="row gx-2 gy-4 gy-xl-0">
                        {/* <!-- My Donation --> */}
                        <div className="col-4 col-md-4">
                        <Link to='/my-donate'>
                            <div className="custom-box card h-100 border-0">
                                
                                <div className="icon">
                                    
                                        <img className="img-fluid" src={assets.account_donate_icon}
                                            alt="My Donation"/>
                                    
                                </div>
                                <p className="mt-auto">My Donation</p>
                               
                            </div>
                            </Link>
                        </div>

                        {/* <!-- Download Certificates --> */}
                        <div className="col-4 col-md-4">
                            <div className="custom-box card h-100 border-0">
                                <div className="icon">
                                    <Link to='' className="stretched-link">
                                        <img src={assets.account_certificate_icon} alt="Download Certificates"/>
                                    </Link>
                                </div>
                                <p className="mt-auto">Download Certificates</p>
                            </div>
                        </div>
                        {/* <!-- Support --> */}
                        <div className="col-4 col-md-4">
                            <Link to='/support-call'>
                            <div className="custom-box card h-100 border-0">
                                <div className="icon">
                                    
                                        <img src={assets.account_support_icon} alt="Support"/>
                                  
                                </div>
                                <p className="mt-auto">Support</p>
                            </div>
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="col-xl-6">
                    <div className="subs_box h-100 card border-0">
                        <div className="text-center">
                            <div className="logo mb-3">
                                <img src={assets.logo} className="img-fluid" alt="logo"/>
                            </div>
                            <div className="mb-3">
                                <p>Manage subscriptions</p>
                            </div>
                            <h6 className="mb-0">Your Total Subscriptions
                                <strong>0</strong>
                            </h6>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mt-5">
                <div className="col-xl-6">
                <Link to='/profile'>
                    <div
                        className="support_box overflow-hidden w-100 position-relative d-flex align-items-center justify-content-between">
                        <div className="item-1">
                            
                            <div className="d-flex align-items-center">
                                <div className="me-2 icon">
                                   
                                        <img src={assets.account_profile_icon} className="img-fluid" alt="profile"/>
                                   
                                </div>
                                <div>
                                    <h5>My Profile</h5>
                                </div>
                            </div>
                            
                        </div>
                        <div className="item-2">
                            <div className="arrow-right">
                            <BsArrowRight/>
                            </div>
                        </div>
                    </div>
                    </Link>
                </div>
                <div className="col-xl-6">
                    <Link to='/volunteer'>
                    <div
                        className="support_box overflow-hidden w-100 position-relative d-flex align-items-center justify-content-between">
                        <div className="item-1">
                            <div className="d-flex align-items-center">
                                <div className="me-2 icon">
                                    
                                        <img src={assets.account_volunteer_icon} className="img-fluid" alt="volunteer"/>
                                    
                                </div>
                                <div>
                                    <h5>Volunteer</h5>
                                </div>
                            </div>
                        </div>
                        <div className="item-2">
                            <div className="arrow-right">
                            <BsArrowRight/>
                            </div>
                        </div>

                    </div>
                    </Link>
                </div>
                <div className="col-xl-6">
                    <div
                        className="support_box overflow-hidden w-100 position-relative d-flex align-items-center justify-content-between">
                        <div className="item-1">
                            <div className="d-flex align-items-center">
                                <div className="me-2 icon">
                                    <Link to='' className="stretched-link">
                                        <img src={assets.account_faq_icon} className="img-fluid" alt="account"/>
                                    </Link>
                                </div>
                                <div>
                                    <h5>FAQ</h5>
                                </div>
                            </div>
                        </div>
                        <div className="item-2">
                            <div className="arrow-right">
                            <BsArrowRight/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-6">
                    <Link to='/refer-donate'>
                    <div
                        className="support_box overflow-hidden w-100 position-relative d-flex align-items-center justify-content-between">
                        <div className="item-1">
                            <div className="d-flex align-items-center">
                                <div className="me-2 icon">
                                    
                                        <img src={assets.account_share_icon} className="img-fluid" alt="account"/>
                                   
                                </div>
                                <div>
                                    <h5>Refer – Spread the Word</h5>
                                </div>
                            </div>
                        </div>
                        <div className="item-2">
                            <div className="arrow-right">
                            <BsArrowRight/>
                            </div>
                        </div>
                    </div>
                    </Link>
                </div>
            </div>
        </div>
    </div>

    </div>
  )
}

export default Account
